import { useState } from "react";

// global
import { accountDataStore, messageAndErrorStore, userStore } from "../../store/Store";

// css and assets
import Close from "../../assets/close.svg";
import { useEscape } from "../../hooks/useEscape";

export default function CommentsPopup({ inv, setTrigger }) {
  const currentCompany = userStore((data) => data.currentCompany);
  const currentUser = userStore((data) => data.currentUser);
  const JwtToken = userStore((data) => data.JwtToken);
  const setAccountReceivedInvoices = accountDataStore(
    (data) => data.setAccountReceivedInvoices
  );
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  const [pending, setPending] = useState(false);
  const [comments, setComments] = useState(inv.comments);

  useEscape(setTrigger);

  const handleClick = () => {
    var reqBody = {
      id: inv.id,
      invoice_status_id: inv.invoice_status_id,
      comments: comments,
      updated_by_id: currentUser.id,
    };

    setPending(true);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const controller = new AbortController();
    const requestOptions = {
      method: "PATCH",
      headers,
      body: JSON.stringify(reqBody),
      signal: controller.abort,
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/lc/account-vendor-invoice/${inv.id}`,
      requestOptions
    )
      .then((res) => {
        if (!res.ok) {
          toggleNewMessage(`${res.statusText} - ${res.status}`);
          setPending(false);
          return Promise.resolve();
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (!data) {
          setPending(false);
          return;
        } else {
          setAccountReceivedInvoices(data.vendor_invoices);
          toggleNewMessage(null, "Invoice Updated");
          setPending(false);
          setTrigger(false);
        }
      })
      .catch((_) => {
        toggleNewMessage("Something went wrong");
        setPending(false);
        return;
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };

  return (
    inv && (
      <div className="popup">
        <div className="popup-inner-add-company">
          {!pending && (
            <img src={Close} onClick={() => setTrigger(false)} alt="close" />
          )}
          {<p>{inv.invoice_name} Comments</p>}
          {inv.target_company_id === currentCompany.id ? (
            <textarea
              required={true}
              type="text"
              name="comments"
              title="Comments"
              placeholder="comments"
              onChange={(e) => setComments(e.target.value)}
              value={comments}
            />
          ) : (
            <textarea
              type="text"
              name="comments"
              title="Comments"
              placeholder="comments"
              defaultValue={inv.comments}
              disabled
            />
          )}
          {!pending && inv.target_company_id === currentCompany.id ? (
            <button className="propx-btn" onClick={handleClick}>
              Update
            </button>
          ) : (
            <button className="propx-btn" onClick={() => setTrigger(false)}>
              Close
            </button>
          )}
          {pending && (
            <button
              className="btn btn-secondary"
              style={{ margin: "20px 20px 20px 0" }}
              disabled
            >
              Submitting...
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          )}
        </div>
      </div>
    )
  );
}
